import { getMetricHelp } from "portal/utils/certifiedMetrics";
import { Metric } from "portal/utils/metrics";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import InfoIcon from "@mui/icons-material/InfoOutlined";
import React, { FunctionComponent } from "react";

interface MetricHelpProps {
  metric: Metric;
  className?: string;
}

export const MetricHelp: FunctionComponent<MetricHelpProps> = ({
  metric,
  className,
}) => {
  const { t } = useTranslation();
  const tooltip = getMetricHelp(t, metric);
  if (!tooltip) {
    return;
  }
  return (
    <Tooltip arrow title={tooltip}>
      <InfoIcon
        color="disabled"
        fontSize="inherit"
        className={className}
        tabIndex={0}
      />
    </Tooltip>
  );
};
